/*!
  Lašty — smart features layer
  Doprava zdarma (progress), quick add z mřížky, upsell v košíku, bundle sety.
  Staví na eventech Impulse: `cart:updated`, `ajaxProduct:added`.
============================================================================*/
(function () {
  'use strict';

  var config = (window.theme && window.theme.lasty) || {};

  /*==========================================================================
    Pomocné funkce
  ==========================================================================*/
  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function routes() {
    return (window.theme && theme.routes) || {
      cart: '/cart.js',
      cartAdd: '/cart/add.js',
      cartPage: '/cart'
    };
  }

  function onCartTemplate() {
    return document.body.classList.contains('template-cart');
  }

  function escapeHtml(text) {
    var d = document.createElement('div');
    d.textContent = text == null ? '' : text;
    return d.innerHTML;
  }

  /* Shopify CDN umí zmenšit obrázek přes parametr width. */
  function sirka(url, px) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }

  function markCartNotEmpty() {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.add('cart-link__bubble--visible');
    });
  }

  /* Přidání položek do košíku. items = [{id, quantity}] */
  function addToCart(items) {
    return fetch(routes().cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status === 422 || data.status === 404) {
            throw data;
          }
          return data;
        });
      })
      .then(function (data) {
        markCartNotEmpty();

        // Na stránce košíku Impulse stejně stránku obnovuje — držíme se toho.
        if (onCartTemplate()) {
          window.scrollTo(0, 0);
          location.reload();
          return data;
        }

        // Drawer si na tento event sám přestaví obsah a otevře se.
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: null }
          })
        );

        // buildCart() v Impulse `cart:updated` nevystřelí, takže si čerstvý
        // košík doneseme sami — na tom stojí lišta dopravy i upsell.
        refreshCart();

        return data;
      });
  }

  function refreshCart() {
    return fetch(routes().cart, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart } })
        );
        return cart;
      })
      .catch(function () {});
  }

  /* Zámek tlačítka — funguje pro <button> i pro div[role=button] */
  function lock(btn) {
    if (!btn.hasAttribute('data-label')) {
      btn.setAttribute('data-label', btn.textContent.trim());
    }
    btn.classList.add('is-busy');
    if ('disabled' in btn) btn.disabled = true;
  }

  function unlock(btn) {
    btn.classList.remove('is-busy', 'is-loading');
    if ('disabled' in btn) btn.disabled = false;
  }

  function isLocked(btn) {
    return btn.classList.contains('is-busy') || btn.classList.contains('is-disabled');
  }

  /* Krátká zpětná vazba na tlačítku */
  function flash(btn, doneLabel) {
    var original = btn.getAttribute('data-label') || btn.textContent.trim();
    btn.setAttribute('data-label', original);
    btn.classList.remove('is-loading');
    btn.classList.add('is-done');
    btn.textContent = doneLabel;
    setTimeout(function () {
      btn.classList.remove('is-done');
      btn.textContent = original;
      unlock(btn);
    }, 1800);
  }

  function fail(btn) {
    unlock(btn);
    btn.textContent = btn.getAttribute('data-label') || btn.textContent.trim();
  }

  /*==========================================================================
    Doprava zdarma — progress lišta
  ==========================================================================*/
  var ShippingBar = {
    init: function () {
      this.render(config.cartTotal || 0);

      document.addEventListener('cart:updated', function (evt) {
        if (evt.detail && evt.detail.cart) {
          ShippingBar.render(evt.detail.cart.total_price);
        }
      });
    },

    render: function (total) {
      document.querySelectorAll('[data-lasty-ship]').forEach(function (bar) {
        var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
        if (!threshold || threshold <= 0) return;

        var textEl = bar.querySelector('[data-lasty-ship-text]');
        var fillEl = bar.querySelector('[data-lasty-ship-fill]');
        var remaining = threshold - total;
        var percent = Math.min(100, Math.round((total / threshold) * 100));

        if (remaining <= 0) {
          bar.classList.add('is-unlocked');
          if (textEl) textEl.innerHTML = bar.getAttribute('data-text-unlocked');
          if (fillEl) fillEl.style.width = '100%';
        } else {
          bar.classList.remove('is-unlocked');
          if (textEl) {
            textEl.innerHTML = bar
              .getAttribute('data-text-progress')
              .replace('[amount]', '<b>' + money(remaining) + '</b>');
          }
          if (fillEl) fillEl.style.width = percent + '%';
        }
      });
    }
  };

  /*==========================================================================
    Quick add v produktové mřížce
    Jedna varianta se přidá rovnou, u víc variant se zespodu vysune panel
    s výběrem velikosti (snippet quick-add-sheet).
  ==========================================================================*/
  var QuickAdd = {
    init: function () {
      document.addEventListener('click', function (evt) {
        var trigger = evt.target.closest('[data-lasty-qa-btn]');
        if (!trigger || isLocked(trigger)) return;

        evt.preventDefault();

        if (trigger.getAttribute('data-mode') === 'variant') {
          QuickAdd.addDirect(trigger, trigger.getAttribute('data-variant-id'));
          return;
        }

        var wrapper = trigger.closest('[data-lasty-qa]');
        var dataEl = wrapper.querySelector('[data-lasty-qa-data]');
        if (!dataEl) return;

        try {
          Sheet.open(JSON.parse(dataEl.textContent), trigger);
        } catch (e) {
          window.location.href = wrapper.querySelector('a') ? wrapper.querySelector('a').href : '/';
        }
      });
    },

    addDirect: function (btn, variantId) {
      if (!variantId) return;

      lock(btn);
      btn.classList.add('is-loading');

      addToCart([{ id: Number(variantId), quantity: 1 }])
        .then(function () {
          flash(btn, config.addedText || 'Hinzugefügt');
        })
        .catch(function () {
          fail(btn);
        });
    }
  };

  /*==========================================================================
    Spodní panel s výběrem velikosti
  ==========================================================================*/
  /* Doporučení v košíku: „Hinzufügen" u produktu s víc velikostmi
     otevře stejný panel jako quick add u dlaždice. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lasty-upsell-options]');
    if (!btn) return;

    var dataEl = btn.parentNode.querySelector('[data-lasty-upsell-data]');
    if (!dataEl) return;

    try {
      Sheet.open(JSON.parse(dataEl.textContent), btn);
    } catch (err) {
      /* Když se panel nepodaří otevřít, ať to aspoň někam vede. */
      var odkaz = btn.parentNode.querySelector('.lasty-upsell__name');
      if (odkaz) window.location.href = odkaz.href;
    }
  });

  var Sheet = {
    el: null,
    lastTrigger: null,

    node: function () {
      if (!this.el) this.el = document.querySelector('[data-lasty-sheet]');
      return this.el;
    },

    init: function () {
      var sheet = this.node();
      if (!sheet) return;

      sheet.addEventListener('click', function (evt) {
        if (evt.target.closest('[data-lasty-sheet-close]')) {
          Sheet.close();
          return;
        }

        var row = evt.target.closest('[data-lasty-sheet-row]');
        if (row && !row.disabled) Sheet.addRow(row);
      });

      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') Sheet.close();
      });
    },

    open: function (data, trigger) {
      var sheet = this.node();
      if (!sheet) return;

      this.lastTrigger = trigger || null;

      var image = sheet.querySelector('[data-lasty-sheet-image]');
      var name = sheet.querySelector('[data-lasty-sheet-name]');
      var price = sheet.querySelector('[data-lasty-sheet-price]');
      var compare = sheet.querySelector('[data-lasty-sheet-compare]');
      var link = sheet.querySelector('[data-lasty-sheet-link]');
      var optionName = sheet.querySelector('[data-lasty-sheet-option-name]');
      var rows = sheet.querySelector('[data-lasty-sheet-rows]');

      if (data.image) {
        image.src = data.image;
        image.alt = data.title || '';
        image.parentNode.hidden = false;
      } else {
        image.parentNode.hidden = true;
      }

      name.textContent = data.title || '';
      name.href = data.url || '#';
      link.href = data.url || '#';
      price.textContent = data.price || '';

      if (data.compareAt) {
        compare.textContent = data.compareAt;
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }

      optionName.textContent = data.optionName || '';

      rows.innerHTML = '';
      (data.rows || []).forEach(function (row) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lasty-sheet__row';
        btn.setAttribute('data-lasty-sheet-row', '');
        btn.setAttribute('data-variant-id', row.id);
        btn.disabled = !row.available;

        var label = document.createElement('span');
        label.className = 'lasty-sheet__row-label';
        label.textContent = row.label;

        var note = document.createElement('span');
        note.className = 'lasty-sheet__row-note';
        note.textContent = row.available
          ? row.price || ''
          : config.soldOutText || 'Ausverkauft';

        btn.appendChild(label);
        btn.appendChild(note);
        rows.appendChild(btn);
      });

      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      // Vynutí reflow, aby se panel vysunul, a ne jen objevil.
      void sheet.offsetHeight;
      sheet.classList.add('is-open');

      var firstRow = rows.querySelector('button:not(:disabled)');
      if (firstRow) firstRow.focus();
    },

    close: function () {
      var sheet = this.node();
      if (!sheet || sheet.hidden) return;

      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';

      var trigger = this.lastTrigger;
      setTimeout(function () {
        sheet.hidden = true;
        if (trigger) trigger.focus();
      }, 300);
    },

    addRow: function (row) {
      if (isLocked(row)) return;

      var note = row.querySelector('.lasty-sheet__row-note');
      lock(row);
      row.classList.add('is-loading');
      if (note) note.textContent = '…';

      addToCart([{ id: Number(row.getAttribute('data-variant-id')), quantity: 1 }])
        .then(function () {
          row.classList.remove('is-loading');
          row.classList.add('is-done');
          if (note) note.textContent = config.addedText || 'Hinzugefügt';
          setTimeout(function () {
            Sheet.close();
          }, 550);
        })
        .catch(function () {
          unlock(row);
          row.classList.remove('is-loading');
          if (note) note.textContent = config.soldOutText || '';
        });
    }
  };

  /*==========================================================================
    Upsell v košíku — schová položky, které už v košíku jsou
  ==========================================================================*/
  var Upsell = {
    /* Produkty, které už jsme jednou doporučili — ať se seznam pod
       každou změnou košíku nepřeskládává. */
    doporucene: null,

    init: function () {
      if (!document.querySelector('[data-lasty-upsell]')) return;

      this.nacti(config.cartProductIds || []);
      this.sync(config.cartProductIds || []);

      document.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-lasty-upsell-add]');
        if (!btn || isLocked(btn)) return;

        evt.preventDefault();
        lock(btn);

        addToCart([{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }])
          .then(function () {
            flash(btn, config.addedText || 'Added');
          })
          .catch(function () {
            fail(btn);
          });
      });

      document.addEventListener('cart:updated', function (evt) {
        if (!evt.detail || !evt.detail.cart) return;
        var ids = evt.detail.cart.items.map(function (item) {
          return item.product_id;
        });
        Upsell.nacti(ids);
        Upsell.sync(ids);
      });
    },

    /* Doporučení podle prvního produktu v košíku. Nepovede-li se to,
       zůstane v seznamu záloha vykreslená z kolekce v nastavení. */
    nacti: function (productIds) {
      if (this.doporucene || !productIds.length) return;
      this.doporucene = [];

      var limit = 6;
      var url =
        (window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/') +
        'recommendations/products.json?product_id=' +
        Number(productIds[0]) +
        '&limit=' +
        limit +
        '&intent=related';

      fetch(url.replace('//recommendations', '/recommendations'), {
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var produkty = (data && data.products) || [];
          if (!produkty.length) return;

          Upsell.doporucene = produkty;
          Upsell.vykresli(produkty);
          Upsell.sync(productIds);
        })
        .catch(function () {});
    },

    vykresli: function (produkty) {
      document.querySelectorAll('[data-lasty-upsell]').forEach(function (wrapper) {
        var list = wrapper.querySelector('[data-lasty-upsell-list]');
        if (!list) return;

        var addLabel = wrapper.getAttribute('data-add-label') || 'Hinzufügen';
        var viewLabel = wrapper.getAttribute('data-view-label') || 'Ansehen';

        list.innerHTML = '';

        produkty.forEach(function (p) {
          if (!p.available) return;

          var jednaVarianta = p.variants && p.variants.length === 1;
          var varianta = (p.variants || []).filter(function (v) {
            return v.available;
          })[0];
          if (!varianta) return;

          var obrazek = p.featured_image || (p.images && p.images[0]) || '';
          /* Tlačítko říká „Hinzufügen" i u produktů s víc velikostmi —
             jen místo přidání naslepo vysune panel s výběrem. Odchod na
             produktovku z doporučení uživatele vytrhne z košíku. */
          var akce;
          if (jednaVarianta) {
            akce = '<button type="button" class="lasty-upsell__add" data-lasty-upsell-add' +
                   ' data-variant-id="' + varianta.id + '"' +
                   ' data-label="' + escapeHtml(addLabel) + '">' + escapeHtml(addLabel) + '</button>';
          } else {
            var nazevVolby = 'Variante wählen';
            if (p.options && p.options.length === 1) {
              nazevVolby = p.options[0].name || p.options[0] || nazevVolby;
            }
            var jednaVolba = !p.options || p.options.length === 1;

            var data = {
              title: p.title,
              url: p.url,
              image: obrazek,
              price: money(p.price),
              compareAt: (p.compare_at_price && p.compare_at_price > p.price) ? money(p.compare_at_price) : null,
              optionName: nazevVolby,
              rows: (p.variants || []).map(function (v) {
                return {
                  id: v.id,
                  label: jednaVolba ? (v.option1 || v.title) : v.title,
                  price: money(v.price),
                  available: v.available
                };
              })
            };

            akce = '<button type="button" class="lasty-upsell__add" data-lasty-upsell-options' +
                   ' data-label="' + escapeHtml(addLabel) + '">' + escapeHtml(addLabel) + '</button>' +
                   '<script type="application/json" data-lasty-upsell-data>' +
                   JSON.stringify(data).replace(/</g, '\\u003c') + '<\/script>';
          }

          var cena = money(p.price);
          if (p.compare_at_price && p.compare_at_price > p.price) {
            cena += '<s>' + money(p.compare_at_price) + '</s>';
          }

          var li = document.createElement('li');
          li.className = 'lasty-upsell__item';
          li.setAttribute('data-upsell-product', p.id);
          li.innerHTML =
            /* Bez fotky se dřív vykreslil prázdný div a řádek se rozpadl.
               Odkaz drží rámeček i tak — tónovanou plošku dodá CSS. */
            '<div class="lasty-upsell__image">' +
            '<a href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
            (obrazek
              ? '<img src="' + sirka(obrazek, 160) + '" alt="" loading="lazy" width="58">'
              : '') +
            '</a>' +
            '</div>' +
            '<div class="lasty-upsell__info">' +
            '<a href="' + p.url + '" class="lasty-upsell__name">' + escapeHtml(p.title) + '</a>' +
            '<div class="lasty-upsell__price">' + cena + '</div>' +
            '</div>' +
            akce;

          list.appendChild(li);
        });
      });
    },

    sync: function (productIds) {
      var ids = productIds.map(Number);
      var wrappers = document.querySelectorAll('[data-lasty-upsell]');

      wrappers.forEach(function (wrapper) {
        var limit = parseInt(wrapper.getAttribute('data-limit'), 10) || 3;
        var shown = 0;

        wrapper.querySelectorAll('[data-upsell-product]').forEach(function (item) {
          var inCart = ids.indexOf(Number(item.getAttribute('data-upsell-product'))) !== -1;

          if (inCart || shown >= limit) {
            item.classList.add('is-hidden');
          } else {
            item.classList.remove('is-hidden');
            shown += 1;
          }
        });

        wrapper.hidden = shown === 0;
      });
    }
  };

  /*==========================================================================
    Bundle sety — přidá všechny produkty setu naráz
  ==========================================================================*/
  var Bundles = {
    init: function () {
      document.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-lasty-bundle-add]');
        if (!btn || isLocked(btn)) return;

        evt.preventDefault();

        var items = (btn.getAttribute('data-variants') || '')
          .split(',')
          .filter(Boolean)
          .map(function (id) {
            return { id: Number(id), quantity: 1 };
          });

        if (!items.length) return;

        lock(btn);
        btn.classList.add('is-loading');

        addToCart(items)
          .then(function () {
            flash(btn, config.addedText || 'Added');
          })
          .catch(function () {
            fail(btn);
          });
      });
    }
  };

  /*==========================================================================
    Produkt-Slider — šipky k vodorovnému pásu
    Samotné listování obstará nativní scroll se snapem, tohle jen posouvá
    o jednu kartu a hlídá, kdy je pás na kraji.
  ==========================================================================*/
  var Rail = {
    init: function () {
      document.querySelectorAll('.lasty-rail-section').forEach(function (sekce) {
        Rail.wire(sekce);
      });
    },

    wire: function (sekce) {
      var rail = sekce.querySelector('[data-lasty-rail]');
      var prev = sekce.querySelector('[data-lasty-rail-prev]');
      var next = sekce.querySelector('[data-lasty-rail-next]');
      if (!rail) return;

      function krok() {
        var karta = rail.querySelector('.grid-product');
        if (!karta) return rail.clientWidth;
        var styl = getComputedStyle(rail.querySelector('.lasty-rail__track'));
        return karta.offsetWidth + (parseFloat(styl.columnGap || styl.gap) || 0);
      }

      function stav() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -krok() }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: krok() }); });

      rail.addEventListener('scroll', stav, { passive: true });
      window.addEventListener('resize', stav);
      stav();
    }
  };

  /*==========================================================================
    Odpočet
  ==========================================================================*/
  var Countdown = {
    init: function () {
      document.querySelectorAll('[data-lasty-countdown]').forEach(function (el) {
        Countdown.start(el);
      });
    },

    start: function (el) {
      var cells = el.querySelectorAll('[data-unit]');
      var fixed = el.getAttribute('data-end');
      var endsAt = null;

      if (fixed) {
        var parsed = new Date(fixed.replace(' ', 'T'));
        if (!isNaN(parsed.getTime())) endsAt = parsed;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        var now = new Date();
        var end = endsAt;

        // Bez pevného data odpočítáváme do půlnoci a startujeme znovu.
        if (!end) {
          end = new Date(now);
          end.setHours(24, 0, 0, 0);
        }

        var diff = end - now;

        if (diff <= 0) {
          if (endsAt) {
            el.closest('[data-lasty-countdown-section]').hidden = true;
            clearInterval(timer);
            return;
          }
          diff = 0;
        }

        var days = Math.floor(diff / 86400000);
        diff -= days * 86400000;
        var hours = Math.floor(diff / 3600000);
        diff -= hours * 3600000;
        var minutes = Math.floor(diff / 60000);
        diff -= minutes * 60000;
        var seconds = Math.floor(diff / 1000);

        var values = { days: days, hours: hours, minutes: minutes, seconds: seconds };

        cells.forEach(function (cell) {
          cell.textContent = pad(values[cell.getAttribute('data-unit')]);
        });
      }

      tick();
      var timer = setInterval(tick, 1000);
    }
  };

  /*==========================================================================
    Rezervace košíku — odpočet nad položkami
    Začátek se drží v sessionStorage, takže se čas nerestartuje při
    každém otevření drawer ani po přechodu na stránku košíku. Po vypršení
    se text vymění za pobídku, nic se nemaže — zákaznice o košík nepřijde.
  ==========================================================================*/
  var CartTimer = {
    KEY: 'lastyCartTimerStart',

    init: function () {
      var els = document.querySelectorAll('[data-lasty-cart-timer]');
      if (!els.length) return;

      this.els = els;
      this.minutes = parseInt(els[0].getAttribute('data-minutes'), 10) || 10;

      var start = this.start();
      if (!start) return;

      this.render();
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(this.render.bind(this), 1000);
    },

    start: function () {
      var stored;
      try {
        stored = window.sessionStorage.getItem(this.KEY);
      } catch (e) {
        stored = null;                       // soukromý režim bez úložiště
      }

      var now = Date.now();
      var value = parseInt(stored, 10);

      /* Uložený čas bereme, jen dokud dává smysl — po vypršení
         i po zavření karty začíná rezervace znovu. */
      if (!value || isNaN(value) || now - value > this.minutes * 60000) {
        value = now;
        try {
          window.sessionStorage.setItem(this.KEY, String(value));
        } catch (e) {}
      }

      this.startedAt = value;
      return value;
    },

    render: function () {
      var left = this.minutes * 60000 - (Date.now() - this.startedAt);
      var expired = left <= 0;

      if (expired) {
        left = 0;
        if (this.timer) clearInterval(this.timer);
      }

      var minutes = Math.floor(left / 60000);
      var seconds = Math.floor((left % 60000) / 1000);
      var clock = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

      Array.prototype.forEach.call(this.els, function (el) {
        var out = el.querySelector('[data-lasty-cart-timer-text]');
        if (!out) return;

        if (expired) {
          el.classList.add('is-expired');
          out.textContent = el.getAttribute('data-text-expired') || '';
        } else {
          out.textContent = (el.getAttribute('data-text') || '').replace('[time]', clock);
        }
      });
    }
  };

  /*==========================================================================
    Start
  ==========================================================================*/
  function init() {
    ShippingBar.init();
    Sheet.init();
    QuickAdd.init();
    Upsell.init();
    Bundles.init();
    Rail.init();
    Countdown.init();
    CartTimer.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sekce znovu vykreslené v editoru motivu si vyžádají nový odpočet.
  document.addEventListener('shopify:section:load', function () {
    Countdown.init();
    Rail.init();
    CartTimer.init();
    ShippingBar.render(config.cartTotal || 0);
    refreshCart();
  });
})();

/* ── tabulka velikostí ────────────────────────────────────────────
   Panel je <dialog>, takže Escape, focus i podklad řeší prohlížeč.
   Posloucháme na dokumentu, aby to fungovalo i po překreslení
   varianty, kdy Impulse část produktovky vymění za novou. */
document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-size-guide-open]');
  if (open) {
    var id = open.getAttribute('data-size-guide-open');
    var panel = document.querySelector('[data-size-guide="' + id + '"]');
    if (panel && typeof panel.showModal === 'function') {
      panel.showModal();
    } else if (panel) {
      panel.setAttribute('open', '');   // starší prohlížeče bez showModal
    }
    return;
  }

  if (e.target.closest('[data-size-guide-close]')) {
    var dlg = e.target.closest('dialog');
    if (dlg) dlg.close();
    return;
  }

  /* Kliknutí vedle panelu ho zavře — dialog sám hlásí i kliky
     na podklad, takže test na hranice obsahu je nutný. */
  var open_dlg = e.target.closest('dialog.lasty-size-guide__panel');
  if (open_dlg) {
    var r = open_dlg.getBoundingClientRect();
    var venku = e.clientX < r.left || e.clientX > r.right ||
                e.clientY < r.top  || e.clientY > r.bottom;
    if (venku) open_dlg.close();
  }
});

/* ------------------------------------------------------------------
   Tabulka velikostí vedle popisku Grösse (podle vzoru)
   Tlačítko zůstává stejné, jen se přesune do řádku s popiskem velikosti.
   Klik obsluhuje delegovaný posluchač výš (data-size-guide-open), takže
   funguje i po přesunu. Dialog zůstává na svém místě.
------------------------------------------------------------------- */
(function () {
  // Popisek velikosti poznáme podle handle volby: grosse, groesse, size, taille
  var jeVelikost = /^(gr|size|taille)/;

  function presun(sloupec) {
    var tlacitko = sloupec.querySelector('.lasty-size-guide__open');
    if (!tlacitko || tlacitko.closest('.lasty-size-row')) return;

    var cil = null;
    sloupec.querySelectorAll('.variant-wrapper fieldset[data-handle]').forEach(function (fs) {
      if (!cil && jeVelikost.test(fs.getAttribute('data-handle') || '')) {
        cil = fs.closest('.variant-wrapper');
      }
    });
    if (!cil) return;

    var popisek = cil.querySelector('.variant__label');
    if (!popisek) return;

    var radek = document.createElement('div');
    radek.className = 'lasty-size-row';
    popisek.parentNode.insertBefore(radek, popisek);
    radek.appendChild(popisek);
    radek.appendChild(tlacitko);

    var obal = sloupec.querySelector('.lasty-size-guide');
    if (obal) obal.classList.add('is-moved');
  }

  function init() {
    document.querySelectorAll('.product-single__meta').forEach(presun);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
